
import InlineLoading from 'vux/src/components/inline-loading/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

export default {
name: 'all',
props: ['sortUp', 'sortName'], // sortUp代表排序初始状态， 不传初始状态为不排序，sortName是排序列的名称
components: {
InlineLoading, Divider, XTable, Tab, TabItem
},
data () {
return {
name: '',
up: true
}
},
created () {
/*获取要排序的列名*/
this.name = this.sortName
},
watch: {
/*检测变动图标*/
sortUp: function (val, oldVal) {
this.up = true
console.log('sortUp:' + val)
}
},
methods: {
/*通知父组件排序*/
onClick () {
this.up = !this.up
if (!this.up) {
this.$emit('sort', {name:this.name, flag: true})
} else {
this.$emit('sort', {name:this.name, flag: false})
}
},
/*初始化*/
init () {
this.up = true
}
}
}



// WEBPACK FOOTER //
// ./src/components/publicComponents/sort.vue